const Home = (): JSX.Element => {
  return <div>Home</div>;
};

export default Home;
